import { supabase } from '../config/supabase'

export const SELECTED_SALON_STORAGE_KEY = 'selected_salon_id'

export const SALON_SELECT_FIELDS =
  'id, name, rating, total_reviews, location, image_urls, description, business_hours, additional_info, email, phone, country_code, currency, city, slug, is_active, latitude, longitude, map_image_urls'

let currentSalonId = null
try {
  currentSalonId = localStorage.getItem(SELECTED_SALON_STORAGE_KEY)
} catch (_e) {
  currentSalonId = null
}

export function getSelectedSalonId() {
  return currentSalonId
}

export function setSelectedSalonId(id) {
  currentSalonId = id || null
  try {
    if (id) localStorage.setItem(SELECTED_SALON_STORAGE_KEY, id)
    else localStorage.removeItem(SELECTED_SALON_STORAGE_KEY)
  } catch (_e) {
    // ignore
  }
}

export async function fetchActiveSalons() {
  const { data, error } = await supabase
    .from('salons')
    .select(SALON_SELECT_FIELDS)
    .eq('is_active', true)
    .order('created_at', { ascending: true })

  if (error) {
    console.error('Error fetching salons:', error)
    return []
  }
  return data || []
}

export function applySalonFilter(query, { includeBrandWide = false, salonId = getSelectedSalonId() } = {}) {
  if (!salonId) return query
  if (includeBrandWide) {
    return query.or(`salon_id.eq.${salonId},salon_id.is.null`)
  }
  return query.eq('salon_id', salonId)
}

export function belongsToSalon(row, salonId = getSelectedSalonId()) {
  if (!salonId) return true
  const rowSalonId =
    row?.salon_id ??
    row?.salonId ??
    row?.originalData?.salon_id ??
    row?.salon?.id ??
    null
  if (rowSalonId == null) return false
  return String(rowSalonId) === String(salonId)
}

export function rowBelongsToSelectedSalon(row, { includeBrandWide = false } = {}) {
  const salonId = getSelectedSalonId()
  if (!salonId) return true
  const rowSalonId = row?.salon_id ?? row?.salonId ?? row?.salon?.id ?? null
  if (includeBrandWide) return rowSalonId === salonId || rowSalonId == null
  return rowSalonId === salonId
}

export function favoriteAppointmentBelongsToSelectedSalon(fav) {
  const salonId = getSelectedSalonId()
  if (!salonId) return true
  const data = fav?.appointment_data || fav || {}
  const rowSalonId = data.salon_id || data.salonId || data.salon?.id || null
  if (rowSalonId) return rowSalonId === salonId
  // Legacy favorites without a location stay visible so old saves are not lost.
  return true
}

/** If a branch has its own row with the same name as the shared catalog, keep one copy. */
export function preferLocationRows(rows, salonId = getSelectedSalonId()) {
  if (!Array.isArray(rows) || rows.length === 0) return rows || []
  const byName = new Map()
  for (const row of rows) {
    const key = String(row?.name || '').trim().toLowerCase()
    if (!key) continue
    const existing = byName.get(key)
    if (!existing || (salonId && row.salon_id === salonId && existing.salon_id !== salonId)) {
      byName.set(key, row)
    }
  }
  return Array.from(byName.values())
}
